module.exports = __webpack_public_path__ + "static/media/impulso.ccf8e6d1.jpg";